{
    "LogFileDownload_DownloadTitle": "**{}** downloaden",
    "LogFileDownload_HowManyFiles": "Hoeveel eerdere bestanden wilt u downloaden?",
    "LogFileDownload_AllFiles": "Alle bestanden",
    "LogFileDownload_NFile": "Vorige {} bestand(en)",
    "LogFileDownload_CurrentFile": "Huidig bestand",
    "NAME": "LanguageLogFileDownload"
}